export default __webpack_public_path__ + "static/media/jea1.06ee49b9.png";